// Native Impower building equipment (Heizung, Aufzug, Zähler, Energieausweis, …) is replaced by Lux
// technical assets (EHV-1200). Only Gebäudeidentifikation (Baujahr) stays.
// Sub-section ids/titles of the equipment section are not stable, so everything in it is hidden except
// the identification block, and sidebar sub-links are matched to the hidden sub-sections by title.
const LUX_NATIVE_EQUIPMENT_ATTR = 'data-lux-native-equipment'
const LUX_NATIVE_EQUIPMENT_SUB_ATTR = 'data-lux-native-equipment-sub'
const LUX_NATIVE_EQUIPMENT_LINK_ATTR = 'data-lux-native-equipment-link'
const LUX_KEPT_EQUIPMENT_SUB_SELECTOR =
  '[id^="buildingIdentification"], [id^="BuildingIdentification"]'
const LUX_KEPT_EQUIPMENT_TITLE_RE = /Gebäudeidentifikation|Baujahr/i
const LUX_NATIVE_EQUIPMENT_STYLES = `
  html[${LUX_NATIVE_EQUIPMENT_ATTR}] .FormSection .sub-section[${LUX_NATIVE_EQUIPMENT_SUB_ATTR}],
  html[${LUX_NATIVE_EQUIPMENT_ATTR}] .FormSidebar .Link.sub-link[${LUX_NATIVE_EQUIPMENT_LINK_ATTR}] { display:none !important; }
`

let nativeEquipmentObserver = null

function nativeEquipmentSubTitle(element) {
  return element.querySelector('.sub-section-title')?.textContent?.trim() || ''
}

function isKeptEquipmentSubSection(sub) {
  return (
    sub.matches(LUX_KEPT_EQUIPMENT_SUB_SELECTOR) ||
    LUX_KEPT_EQUIPMENT_TITLE_RE.test(nativeEquipmentSubTitle(sub))
  )
}

function toggleNativeEquipmentMark(element, attr, on) {
  if (on !== element.hasAttribute(attr)) element.toggleAttribute(attr, on)
}

function markNativeEquipmentUi() {
  const hiddenTitles = new Set()
  document
    .querySelectorAll('.FormSection[id^="BuildingEquipment"] .sub-section')
    .forEach((sub) => {
      const hidden = !isKeptEquipmentSubSection(sub)
      toggleNativeEquipmentMark(sub, LUX_NATIVE_EQUIPMENT_SUB_ATTR, hidden)
      if (hidden && nativeEquipmentSubTitle(sub)) {
        hiddenTitles.add(nativeEquipmentSubTitle(sub))
      }
    })
  document
    .querySelectorAll('.FormSidebar .Link.main-link')
    .forEach((mainLink) => {
      const sectionId = mainLink.dataset.sectionId
      const nativeLink = !sectionId || sectionId.startsWith('BuildingEquipment')
      mainLink.querySelectorAll('.Link.sub-link').forEach((link) => {
        const title =
          link.querySelector('.link-title')?.textContent?.trim() || ''
        toggleNativeEquipmentMark(
          link,
          LUX_NATIVE_EQUIPMENT_LINK_ATTR,
          nativeLink && hiddenTitles.has(title)
        )
      })
    })
}

function keepNativeEquipmentMarked() {
  if (!document.getElementById('luxNativeEquipmentStyles')) {
    const style = document.createElement('style')
    style.id = 'luxNativeEquipmentStyles'
    style.textContent = LUX_NATIVE_EQUIPMENT_STYLES
    document.head.appendChild(style)
  }
  markNativeEquipmentUi()
  if (nativeEquipmentObserver) return
  // Runs before paint, so re-rendered native equipment never flashes.
  nativeEquipmentObserver = new MutationObserver(markNativeEquipmentUi)
  nativeEquipmentObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  })
}

function hideNativeEquipmentUi() {
  keepNativeEquipmentMarked()
  document.documentElement.toggleAttribute(LUX_NATIVE_EQUIPMENT_ATTR, true)
}

function releaseNativeEquipmentUi() {
  document.documentElement.removeAttribute(LUX_NATIVE_EQUIPMENT_ATTR)
  nativeEquipmentObserver?.disconnect()
  nativeEquipmentObserver = null
}

/** True while native equipment is hidden; Lux heating extras stay off. */
function isNativeEquipmentHidden() {
  return document.documentElement.hasAttribute(LUX_NATIVE_EQUIPMENT_ATTR)
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    LUX_NATIVE_EQUIPMENT_SUB_ATTR,
    LUX_NATIVE_EQUIPMENT_LINK_ATTR,
    hideNativeEquipmentUi,
    releaseNativeEquipmentUi,
    isNativeEquipmentHidden,
    markNativeEquipmentUi,
  }
}
